import React from "react";
import { Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import ProductPageComponent from "../components/product/product/ProductPageComponent";
import ProductDetailComponent from "../components/product/product_detail/ProductDetailComponent";
import CurriculumContent from "../components/curriculum/CurriculumContent";
import { useEffectOnce } from "../redux/hooks/useEffectOnce";
import {
    actionToGetBrandDataApiCall,
    actionToGetCategoriesDataApiCall,
    actionToGetGradesDataApiCall,
    actionToGetProductsListApiCall,
} from "../redux/action";

const ProductPage = () => {
    const dispatch = useDispatch();

    useEffectOnce(() => {
        const fetchData = async () => {
            // Dispatch API calls concurrently
            await Promise.all([
                dispatch(actionToGetProductsListApiCall()),
                dispatch(actionToGetCategoriesDataApiCall()),
                dispatch(actionToGetGradesDataApiCall()),
                dispatch(actionToGetBrandDataApiCall()),
            ]);
        };

        fetchData();
    });
    const pageId = Date.now(); // Generates a unique timestamp
    return (
        <Routes>
            <Route path="/" element={<ProductPageComponent key={pageId}/>} />
            <Route path=":product_slug" element={<ProductDetailComponent key={pageId} />} />
            <Route path=":product_slug/curriculum" element={<CurriculumContent key={pageId} />} />
        </Routes>
    );
};

export default ProductPage;
